<loading *ngIf="loading">
  <ng-container i18n="@@front.resetPassword.loading">Loading your information</ng-container>
</loading>

<error *ngIf="error">
  <p>{{error}}</p>
  <a routerLink="/home" class="btn btn-primary" i18n="@@front.resetPassword.error.actionButton">Home Page</a>
</error>

<success *ngIf="success">
  <p i18n="@@front.resetPassword.success.message">Your password has been reset successfully</p>
  <a routerLink="/login" class="btn btn-front btn-lg btn-primary" i18n="@@front.resetPassword.success.actionButton">Login</a>
</success>

<div *ngIf="!loading && !success && !error">
  <div *ngIf="errorNotification" class="alert alert-warning">
    {{errorNotification}}
  </div>

  <form [formGroup]="form" (ngSubmit)="resetPassword()">
    <p *ngIf="isSMS()" class="text-center" i18n="@@front.resetPassword.smsDescription">an SMS code has been sent to {{phoneNumber}}, please enter the details below to reset your password</p>
    <p *ngIf="isTOTP()" class="text-center" i18n="@@front.resetPassword.totpDescription">Please fill out your TOTP code in the below form</p>

    <otp-input [otpControl]="otpCode"></otp-input>

    <password-complexity
      formControlName="password"
      label="New Password"
      data-testid="register-resetPassword-newPassword-txt"
      placeholder="Enter your new password"
      i18n-label="@@front.resetPassword.passowrd.label"
      i18n-placeholder="@@front.resetPassword.password.placeholder"
    ></password-complexity>

    <div class="submit">
      <button type="submit" data-testid="register-resetPassword-btn" class="btn btn-front btn-lg btn-primary d-block w-100" [disabled]="!form.valid">
        <ng-container *ngIf="!loading" i18n="@@front.resetPassword.submitButton">Reset Password</ng-container>
        <ng-container *ngIf="loading" i18n="@@front.login.form.loading">Loading...</ng-container>
      </button>
    </div>
    <div class="text-center pt-3">
      <button *ngIf="!isNone() && isSmsEnabled()" data-testid="register-resetPassword-resendSMS-btn" class="btn btn-outline" (click)="sendSms()">
        <ng-container *ngIf="isSMS()" i18n="@@front.resetPassword.resendSms">Re-Send SMS code</ng-container>
        <ng-container *ngIf="isTOTP()" i18n="@@front.resetPassword.sendSmsInstead">Send an SMS instead</ng-container>
      </button>
    </div>
  </form>
</div>
